module.exports = __webpack_public_path__ + "img/hr-branch-particle-19.812ca333.png";